import { Injectable } from '@angular/core';
import { MultiselectProvider } from '../multiselect-provider';
import { Observable, Observer } from 'rxjs';
import { MultiselectOptionItem, UiConstants } from '../../util/core-utils';
import { OrderType, QueryResult } from '../util/services';
import { Set } from 'immutable';
import { Customer, CustomerService } from './customer.service';
import { map } from 'rxjs/operators';
import { ConfigurationService } from '../configuration/configuration.service';
import { Address } from '../address';

@Injectable()
export class CustomerMultiselectProvider implements MultiselectProvider {

  private multiselectQueryRequest: Customer.QueryRequest = {
    paging: {
      pageNumber: 1,
      numberOfItems: UiConstants.autocompletePageSize
    },
    noProgressBar: true,
    orders: Set.of({field: Customer.OrderField.NAME, type: OrderType.ASC})
  };

  constructor(private customerService: CustomerService,
              private configurationService: ConfigurationService) {
  }

  load(queryRequest: Customer.QueryRequest): Observable<MultiselectOptionItem<number>[]> {
    return Observable.create((observer: Observer<MultiselectOptionItem<number>[]>) => {
      this.customerService.query(queryRequest).subscribe((result: QueryResult<Customer.Customer>) => {
          observer.next(result.items.toArray().map(item => this.toMultiselectOptionItem(item!)));
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  loadAll(predicate?: string): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign({}, this.multiselectQueryRequest);
    queryRequest.queryText = predicate;
    return this.load(queryRequest);
  }

  loadActive(predicate?: string): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign({}, this.multiselectQueryRequest);
    queryRequest.queryText = predicate;
    queryRequest.disabled = false;
    return this.load(queryRequest);
  }

  loadActiveNonContact(predicate?: string): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign({}, this.multiselectQueryRequest);
    queryRequest.queryText = predicate;
    queryRequest.contactPerson = false;
    queryRequest.disabled = false;
    return this.load(queryRequest);
  }

  getById(id: number): Observable<MultiselectOptionItem<number>> {
    const queryRequest = Object.assign([], this.multiselectQueryRequest);
    queryRequest.customerIdSet = Set.of(id);
    return this.load(queryRequest).pipe(map(result => result[0]));
  }

  getByIds(ids: number[]): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign([], this.multiselectQueryRequest);
    queryRequest.customerIdSet = Set.of(...ids);
    queryRequest.paging = undefined;
    return this.load(queryRequest);
  }

  toMultiselectOptionItem(item: Customer.Customer): MultiselectOptionItem<number> {
    const ret = new MultiselectOptionItem<number>();
    ret.id = item.customerId;
    ret.itemName = item.name;
    ret.itemSubtitle = item.externalId;
    ret.disabled = item.disabled;
    return ret;
  }

}
